// extracted by mini-css-extract-plugin
export default {"container":"Highlight_container__lqK0Q","highlight":"Highlight_highlight__oeWF2","highlight-section":"Highlight_highlight-section__n8bCN"};